import { g as n } from "../../utils-BOfnFgIH.js";
import { I as i } from "../../constants-DeVuDy8J.js";
import { createElementBlock as d, openBlock as r, normalizeClass as o, createElementVNode as a } from "vue";
import { _ as l } from "../../_plugin-vue_export-helper-CHgC5LLL.js";
const c = {
  name: "DtIconTask",
  props: {
    /**
     * The size of the icon.
     * @values 100, 200, 300, 400, 500, 600, 700, 800
     */
    size: {
      type: String,
      default: "500",
      validator: (e) => Object.keys(i).includes(e)
    },
    /**
     * The label of the icon as read out by a screenreader. Leave this unset if your icon is purely presentational
     */
    ariaLabel: {
      type: String,
      default: void 0
    }
  },
  /**
  * @TODO: Remove this emit once the icons migration is complete,
  * they will no longer need this event.
  * */
  emits: ["loaded"],
  computed: {
    iconSizeClass() {
      return i[this.size];
    },
    ariaHidden() {
      return this.ariaLabel ? "false" : "true";
    },
    dataQA() {
      return this.$attrs["data-qa"] ?? "dt-icon";
    }
  },
  created() {
    this.$emit("loaded"), this.uniqueID = n();
  }
}, _ = ["aria-label", "data-qa", "aria-hidden"], u = ["clip-path"], h = /* @__PURE__ */ a("path", { d: "M4.943 2.081a4.058 4.058 0 0 1 2.554.147.5.5 0 0 0 .369-.93 5.058 5.058 0 1 0 3.188 4.499.5.5 0 0 0-.999.04A4.059 4.059 0 1 1 4.943 2.08Z" }, null, -1), p = /* @__PURE__ */ a("path", { d: "M10.9 2.854a.5.5 0 1 0-.706-.708L6 6.34 4.807 5.133a.5.5 0 1 0-.71.704l1.548 1.562a.5.5 0 0 0 .708.002l4.548-4.547Z" }, null, -1), f = [
  h,
  p
], m = ["id"], g = /* @__PURE__ */ a("path", {
  fill: "#fff",
  d: "M0 0h12v12H0z"
}, null, -1), I = [
  g
];
function b(e, q, s, S, k, t) {
  return r(), d("svg", {
    "aria-label": s.ariaLabel,
    class: o([t.iconSizeClass, "d-icon d-icon--task"]),
    "data-qa": t.dataQA,
    "aria-hidden": t.ariaHidden,
    role: "img",
    "data-name": "Task",
    viewBox: "0 0 12 12",
    xmlns: "http://www.w3.org/2000/svg"
  }, [
    a("g", {
      "clip-path": `url(#${e.uniqueID}a)`,
      fill: "currentColor"
    }, f, 8, u),
    a("defs", null, [
      a("clipPath", {
        id: `${e.uniqueID}a`
      }, I, 8, m)
    ])
  ], 10, _);
}
const D = /* @__PURE__ */ l(c, [["render", b]]);
export {
  D as default
};
//# sourceMappingURL=task.js.map
